
import { wrapColumn, wrapRow } from './shared.js';
import { SharedBigRoad} from './shared-big-road.js';
import { DownRoad, generateDownRoadData} from './down-road.js';


function generateCockroachRoadItemList(bigRoadItemGraph) {
    return generateDownRoadData(bigRoadItemGraph, 3);//DownRoadGap.CockroachRoadGap);
}
function generateCockroachRoadRoadGraph(bigRoadGraph, rowCount, columnCount) {
    return wrapRow(wrapColumn(generateCockroachRoadItemList(bigRoadGraph), (previousItem, currentItem) => previousItem.repetition === currentItem.repetition), rowCount, columnCount);
}
class CockroachRoad extends DownRoad {
    constructor(row, column, roundResults) {
        super(row, column, roundResults);
        this.row = row;
        this.column = column;
        this.roundResults = roundResults;
        const bigRoad = new SharedBigRoad(row, roundResults.length, roundResults);
        this.array = generateCockroachRoadRoadGraph(bigRoad.rawArray, row, column);
    }
    get bankerPrediction() {
        const fakeNextRound = {
            order: this.roundResults.length,
            result: 0, // Dummy
            gameResult: 1,//GameResult.BankerWin,
            pairResult: 0.//PairResult.NoPair,
        };
        return this.getPrediction(fakeNextRound, 3);//DownRoadGap.CockroachRoadGap);
    }
    get playerPrediction() {
        const fakeNextRound = {
            order: this.roundResults.length,
            result: 0, // Dummy
            gameResult: 2,//GameResult.PlayerWin,
            pairResult: 0,//PairResult.NoPair,
        };
        return this.getPrediction(fakeNextRound, 3);//DownRoadGap.CockroachRoadGap);
    }
}

export {CockroachRoad}